<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="店铺保证金" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="header">
            <div class="title">应缴保证金</div>
            <div class="amount">￥{{store_info.store_payable_deposit}}</div>
            <div class="desc-wrapper">
                <div class="desc">已缴：{{store_info.store_avaliable_deposit}}</div>
                <div class="desc">审核：{{store_info.store_freeze_deposit}}</div>
            </div>
        </div>
        <div class="main-content">
            <div  @click="goSellerDepositList">
                <flex-line :is-link="true" :show-border="true"><span class="line-name">保证金明细</span></flex-line>
            </div>
            <div  @click="goSellerDepositWithdrawList">
                <flex-line :is-link="true" :show-border="true"><span class="line-name">保证金审核</span></flex-line>
            </div>
            <div @click="addDeposit">
                <flex-line :is-link="true" :show-border="true"><span class="line-name">补缴保证金</span></flex-line>
            </div>
            <div @click="reduceDeposit">
                <flex-line :is-link="true" :show-border="true"><span class="line-name">取出保证金</span></flex-line>
            </div>
        </div>
    </div>
</template>

<script>
import { Toast, MessageBox } from 'mint-ui'
import { getSellerInfo } from '../../../api/seller'
import { addSellerDeposit, reduceSellerDeposit } from '../../../api/sellerDeposit'
import flexLine from '../../flexLine'
export default {
  name: 'Index',
  data () {
    return {
      store_info: {}
    }
  },
  components: { flexLine },
  created: function () {
    this.getSellerInfo()
  },
  methods: {
    getSellerInfo () {
      getSellerInfo().then(response => {
        if (response && response.result) {
          this.store_info = response.result.store_info
        }
      }
      ).catch(function (error) {
        Toast(error.message)
      })
    },
    // 店铺保证金明细
    goSellerDepositList () {
      this.$router.push({ name: 'SellerDepositList' })
    },
    // 保证金审核列表
    goSellerDepositWithdrawList () {
      this.$router.push({ name: 'SellerDepositWithdrawList' })
    },
    // 申请提现
    addDeposit () {
      MessageBox.prompt('请输入补缴金额', '').then(({ value, action }) => {
        addSellerDeposit(value).then(res => {
          this.getSellerInfo()
          Toast(res.message)
        }).catch(function (error) {
          Toast(error.message)
        })
      })
    },
    reduceDeposit () {
      MessageBox.prompt('请输入取出金额', '').then(({ value, action }) => {
        reduceSellerDeposit(value).then(res => {
          this.getSellerInfo()
          Toast(res.message)
        }).catch(function (error) {
          Toast(error.message)
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
    .common-header-wrap .common-header{box-shadow: unset}
    .main-content{background: #fff;padding:0 $pageSpace}
    .header{background: $primaryColor;position: relative;color: #fff;padding:1rem $pageSpace;
        .title{font-size:$h2}
        .amount{font-size:1.6rem;text-align: center;padding:1rem 0;}
        .desc-wrapper{display: flex;
            .desc{flex:1;font-size:$h2 }
        }
    }
</style>
